__turbopack_context__.v({
  "root": "report-action-module-scss-module__NJ1WEa__root",
});
